package com.tregz.tremenz.io.player

import kotlinx.browser.document
import org.w3c.dom.HTMLVideoElement

actual class PlayerMedia actual constructor() {

    val element: HTMLVideoElement =
        (document.createElement("video") as HTMLVideoElement).apply {
            autoplay = false
            controls = true
            setAttribute("playsinline", "true")
            setAttribute("webkit-playsinline", "true")
            style.position = "fixed"
            style.objectFit = "contain"
            style.backgroundColor = "black"
            style.zIndex = "4"
            style.visibility = "hidden"
        }

    actual val isPlaying: Boolean
        get() = !element.paused && !element.ended

    fun load(url: String) {
        element.src = url
        element.load()
    }

    actual fun start() {
        // Older engines return undefined instead of a Promise.
        val promise: dynamic = element.play()
        if (promise != null && jsTypeOf(promise.then) == "function") {
            promise.catch { e: dynamic ->
                console.error("Error starting video playback:", e)
            }
        }
    }

    actual fun pause() {
        element.pause()
    }

    actual fun stop() {
        element.pause()
        element.currentTime = 0.0
        element.removeAttribute("src")
        element.load()
        element.style.visibility = "hidden"
    }
}
